export default function Casilla({ casilla,clicked, key }: { casilla: any; key:any; clicked:any }) {

if(casilla.num_act==-1){ 
    return (
    
    <button className={"casillasudoku "+ (casilla.bloqueado===1? 'bloqueada ' :'') +" " +(casilla.seleccionado===1? 'seleccionada ' :'')+" " +(casilla.conflicto===1? 'conflicto ' :'')} onClick={clicked}>

        <span className="grid-candidatos">
            <span className="candidato">{(casilla.candidatos[0]==1? '1' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[1]==1? '2' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[2]==1? '3' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[3]==1? '4' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[4]==1? '5' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[5]==1? '6' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[6]==1? '7' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[7]==1? '8' :' ')}</span>
            <span className="candidato">{(casilla.candidatos[8]==1? '9' :' ')}</span>
        </span>



            {/*
            <table className="tableCandidatos">
            <tbody className="tableCandidatos">
                <tr>
                    <td className="casillaCandidato">{(casilla.candidatos[0]==1? '1' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[1]==1? '2' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[2]==1? '3' :' ')}</td>
                </tr>
                <tr>
                    <td className="casillaCandidato">{(casilla.candidatos[3]==1? '4' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[4]==1? '5' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[5]==1? '6' :' ')}</td>
                </tr>
                <tr>
                    <td className="casillaCandidato">{(casilla.candidatos[6]==1? '7' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[7]==1? '8' :' ')}</td>
                    <td className="casillaCandidato">{(casilla.candidatos[8]==1? '9' :' ')}</td>
                </tr>
                </tbody>
            </table>
            */}






        </button>);
}else{
    return (<button className={"casillasudoku "+ (casilla.bloqueado===1? 'bloqueada ' :'') +" " + (casilla.seleccionado===1? 'seleccionada ' :'')+" " +(casilla.conflicto===1? 'conflicto ' :'')}  onClick={clicked}>{casilla.num_act}</button>);
}


   
  
}